module.exports = __webpack_public_path__ + "static/img/hello-hr.e8eae37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/screenshots/hello-hr.png
// module id = rqfj
// module chunks = 0